import { render, staticRenderFns } from "./ProductPoint.vue?vue&type=template&id=045490d4&"
import script from "./ProductPoint.vue?vue&type=script&lang=js&"
export * from "./ProductPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports